module.exports = __webpack_public_path__ + "static/media/12UNCTAD3.a5aa2c77.jpg";